import React from 'react'
import { useSelector } from 'react-redux'
import { selectUserUIScreen } from '../../../store/ui/ui.selectors'
import { USER_SCREENS } from '../../../store/ui/ui.constants'
import UserFavorites from './userFavorites/UserFavorites'
import UserTravelOptions from './userTravelOptions/UserTravelOptions'
import UserMenu from './userMenu/UserMenu'
import UserManageFavorite from './userFavorites/UserManageFavorite'
import { withUserConnected } from '../shared/withKeycloak'

const UserAreaConnected = () => {
  const screen = useSelector(selectUserUIScreen)

  switch (screen) {
    case USER_SCREENS.favorites:
      return <UserFavorites />
    case USER_SCREENS.manageFavorite:
      return <UserManageFavorite />
    case USER_SCREENS.travelOptions:
      return <UserTravelOptions />
    case USER_SCREENS.default:
    default:
      return <UserMenu />
  }
}

export default withUserConnected(UserAreaConnected)
